const getCustomers = state => state.customers

const getUser = state => state.auth.user

const getSearchUser = state => state.searchRegisterUser

const getRegisterUser = state => state.register

export default {
  getUser,
  getSearchUser,
  getRegisterUser,
  getCustomers
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js